
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.813 6.125c.71 0 1.312.602 1.312 1.313v5.25c0 .738-.602 1.312-1.313 1.312H2.188a1.296 1.296 0 01-1.313-1.313v-5.25c0-.71.574-1.312 1.313-1.312h.437v-1.75A4.388 4.388 0 017 0c2.406.027 4.375 2.023 4.375 4.43v1.695h.438zm-4.266 4.813c0 .3-.246.546-.547.546a.548.548 0 01-.547-.546v-1.75c0-.301.246-.547.547-.547.3 0 .547.246.547.546v1.75zM3.5 6.125v-1.75c0-1.914 1.559-3.5 3.5-3.5 1.914 0 3.5 1.586 3.5 3.5v1.75h-7zm8.313 7a.45.45 0 00.437-.438v-5.25A.47.47 0 0011.812 7H2.188a.45.45 0 00-.438.438v5.25c0 .246.191.437.438.437h9.624z","fill":"#212121"}})])
          )
        }
      }
    